<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
            <el-table :data="form" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="sex" label="性别" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="phone" label="手机号码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="deptName" label="部门" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="gw" label="职位" :show-overflow-tooltip="true" width="120"></el-table-column>
				<el-table-column prop="fixedPhone" label="固定电话" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="ywDb" label="业务代表" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="zjType" label="证件类型" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="zjCode" label="证件号码" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
			</el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowLxrInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
		}
	};
</script>
<style scoped="scoped">
</style>